import React, { useState } from 'react';

const COLORS = ['#38bdf8', '#22d3ee', '#34d399', '#fbbf24', '#f87171', '#a78bfa', '#f472b6', '#fb923c', '#818cf8', '#4ade80'];

export default function ProgressChart({ series = [] }) {
  const [visible, setVisible] = useState(new Set(series.slice(0, 4).map(s => s.id)));
  const width = 720, height = 300, pad = { l: 40, r: 20, t: 20, b: 30 };

  const allPoints = series.flatMap(s => s.data.map(d => d.val));
  const maxVal = 10;
  const dates = series[0]?.data.map(d => d.date) || [];
  const n = dates.length;

  const x = i => pad.l + (i * (width - pad.l - pad.r)) / Math.max(1, n - 1);
  const y = v => pad.t + ((maxVal - v) / maxVal) * (height - pad.t - pad.b);

  const toggle = (id) => {
    const next = new Set(visible);
    next.has(id) ? next.delete(id) : next.add(id);
    setVisible(next);
  };

  if (n < 2) return <div className="text-center text-slate-500 py-12">Need at least 2 evaluations to show progress.</div>;

  return (
    <div>
      <svg viewBox={`0 0 ${width} ${height}`} className="w-full h-auto">
        {[0, 2.5, 5, 7.5, 10].map(v => (
          <g key={v}>
            <line x1={pad.l} x2={width - pad.r} y1={y(v)} y2={y(v)} stroke="#e2e8f0" strokeDasharray="3 3" />
            <text x={pad.l - 6} y={y(v) + 3} textAnchor="end" fontSize={10} fill="#64748b">{v}</text>
          </g>
        ))}
        {dates.map((d, i) => (
          <text key={i} x={x(i)} y={height - 10} textAnchor="middle" fontSize={10} fill="#64748b">
            {new Date(d).toLocaleDateString('en-US', { month: 'short', day: 'numeric' })}
          </text>
        ))}
        {series.map((s, si) => {
          if (!visible.has(s.id)) return null;
          const path = s.data.map((d, i) => `${i === 0 ? 'M' : 'L'} ${x(i)} ${y(d.val)}`).join(' ');
          return (
            <g key={s.id}>
              <path d={path} fill="none" stroke={COLORS[si % COLORS.length]} strokeWidth={2} />
              {s.data.map((d, i) => (
                <circle key={i} cx={x(i)} cy={y(d.val)} r={3} fill={COLORS[si % COLORS.length]} />
              ))}
            </g>
          );
        })}
      </svg>
      <div className="mt-4 flex flex-wrap gap-2">
        {series.map((s, i) => {
          const on = visible.has(s.id);
          return (
            <button key={s.id} onClick={() => toggle(s.id)}
              className={`text-xs px-2.5 py-1 rounded-full border transition-colors ${
                on ? 'text-slate-900' : 'text-slate-500 border-slate-200'
              }`}
              style={on ? { borderColor: COLORS[i % COLORS.length], backgroundColor: `${COLORS[i % COLORS.length]}22` } : {}}>
              <span className="inline-block h-2 w-2 rounded-full mr-1.5" style={{ backgroundColor: COLORS[i % COLORS.length] }} />
              {s.name}
            </button>
          );
        })}
      </div>
    </div>
  );
}
